import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/api';
import './Auth.css';

export const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [devLink, setDevLink] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setDevLink(null);
    setLoading(true);

    try {
      const res = await authApi.forgotPassword(email);
      setSuccessMessage(res.message || 'Şifre sıfırlama bağlantısı e-posta adresinize gönderildi.');
      if (res.devResetLink) {
        setDevLink(res.devResetLink);
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Şifre sıfırlama talebi gönderilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-logo-badge">🔑</div>
          <h2 className="auth-title">Şifremi Unuttum</h2>
          <p className="auth-subtitle">
            Kayıtlı e-posta adresinizi girin, şifrenizi yenilemeniz için güvenli bir bağlantı gönderelim.
          </p>
        </div>

        {error && <div className="auth-alert error">⚠️ {error}</div>}

        {successMessage ? (
          <div style={{ textAlign: 'center' }}>
            <div className="auth-alert success">
              ✅ {successMessage}
            </div>

            <p style={{ color: '#64748b', fontSize: '0.85rem', lineHeight: 1.5, margin: '16px 0' }}>
              Lütfen gelen kutunuzu (ve gerekiyorsa spam / gereksiz klasörünü) kontrol ediniz. Bağlantı 1 saat geçerlidir.
            </p>

            {devLink && (
              <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', padding: '12px', borderRadius: '8px', margin: '16px 0', wordBreak: 'break-all', fontSize: '0.8rem' }}>
                <strong style={{ color: '#2563eb' }}>[Geliştirici / Test Bağlantısı]:</strong><br />
                <a href={devLink} style={{ color: '#2563eb', fontWeight: 600 }}>{devLink}</a>
              </div>
            )}

            <div className="auth-footer-nav" style={{ marginTop: '24px' }}>
              <Link to="/login" style={{ fontWeight: 700, color: '#2563eb' }}>
                ← Giriş Ekranına Geri Dön
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>Kayıtlı E-Posta Adresiniz</label>
              <input
                type="email"
                placeholder="ornek@uzmanisg.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="auth-input"
                autoFocus
              />
            </div>

            <button type="submit" className="auth-submit-btn" disabled={loading}>
              {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder 📨'}
            </button>

            <div className="auth-footer-nav" style={{ marginTop: '14px' }}>
              Şifrenizi hatırladınız mı? <Link to="/login">Giriş Yapın</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
